import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bonusomat-main floor bs-container" }
const _hoisted_2 = { class: "bonusomat-main__column" }
const _hoisted_3 = { class: "bonusomat-main__section bonusomat-main__section--double" }
const _hoisted_4 = { class: "bonusomat-main__section bonusomat-main__section--board" }
const _hoisted_5 = { class: "bonusomat-main__column bonusomat-main__column--quests" }
const _hoisted_6 = { class: "bonusomat-main__section bonusomat-main__section--quests" }

import { onMounted } from "vue";
import { useKeepAlive } from "@sazka/ng/ng-keep-session-alive";
import BonusomatBoard from "./board/bonusomat-board.vue";
import BonusomatOnboarding from "./onboarding/bonusomat-onboarding.vue";
import BonusomatQuests from "./quests/bonusomat-quests.vue";
import BonusomatRaffle from "./raffle/bonusomat-raffle.vue";
import BonusomatSlots from "./slots/bonusomat-slots.vue";
import useBonusomatData from "../composables/use-bonusomat-data";
import { BonusomatDatalayer } from "../utils/analytics/bonusomat-datalayer";


export default /*@__PURE__*/_defineComponent({
  __name: '_bonusomat-main',
  setup(__props) {

const { initBonusomatData } = useBonusomatData();

initBonusomatData();

onMounted(async () => {
    BonusomatDatalayer.pushMainPageShow();
    useKeepAlive();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(BonusomatSlots),
          _createVNode(BonusomatRaffle)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(BonusomatBoard)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(BonusomatQuests)
        ])
      ])
    ]),
    _createVNode(BonusomatOnboarding)
  ], 64))
}
}

})